import Service from "./Service";
const baseurl = '/api/formularios-trimestre';

export default {
    trimestresUsuarios(id,id_historia){
        return Service.get(`${baseurl}/show-trimestres-by-user/${id}/${id_historia}`);
    }
}
